
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart/other-items",
      function () {
        return require("private-next-pages/cart/other-items/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cart/other-items"])
      });
    }
  